import { FaWhatsapp } from "react-icons/fa6";
import { ModalWraper } from "../../../../../../components/modal/wraper";
import { useState, useEffect } from "react";
import { WaDeviceService } from "../../../../../../services/WaDeviceService";
import { FaSave } from "react-icons/fa";
import { InputDefault } from "../../../../../../components/forms/InputDefault";

export const UpdateWaDeviceModal = ({ openModal, setOpenModal, refreshData, selectedDevice }) => {
    const [loading, setLoading] = useState(false);
    
    // State form diisi dengan data default, nanti akan di-update oleh useEffect
    const [deviceForm, setDeviceForm] = useState({
        name: "",
        primary: false,
        phone_number: "",
    });

    // Efek untuk mengisi form data saat modal dibuka dan device dipilih
    useEffect(() => {
        if (openModal && selectedDevice) {
            setDeviceForm({
                name: selectedDevice.name || "",
                primary: selectedDevice.primary || false,
                phone_number: selectedDevice.phone_number || "",
            });
        } else if (!openModal) {
            // Reset form saat modal ditutup
            setDeviceForm({ name: "", primary: false, phone_number: "" });
        }
    }, [openModal, selectedDevice]);

    const handleUpdateDevice = async (e) => {
        e.preventDefault();
        if (!selectedDevice?.id) return; // Pastikan ada ID device

        setLoading(true);

        // Payload sesuai request->validate di backend
        const payload = {
            name: deviceForm.name,
            primary: deviceForm.primary,
            phone_number: deviceForm.phone_number,
        };

        try {
            // Panggil service update dengan ID device
            const response = await WaDeviceService.update({ id: selectedDevice.id, data: payload });

            if (response.data.status) {
                alert(response.data.message || "Perangkat berhasil diperbarui!");
                
                setOpenModal(false);
                refreshData();
            } else {
                alert(response.data.message || "Gagal memperbarui device.");
            }
        } catch (error) {
            console.error("Error update device:", error);
            let errorMessage = "Terjadi kesalahan pada server.";

            if (error.response && error.response.status === 422) {
                const errors = error.response.data.errors;
                errorMessage = Object.values(errors)[0][0];
            } else if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            alert(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalWraper
            isOpen={openModal} 
            setIsOpen={setOpenModal}
            title={<h3 className="text-white">Edit Perangkat</h3>}
            icon={<FaWhatsapp className="text-cyan-500 text-xl" />}
        >
            <form onSubmit={handleUpdateDevice} className="space-y-5">
                
                {/* --- Toggle Primary --- */}
                <div className="flex items-center justify-between p-3 bg-slate-800/30 rounded-xl border border-slate-700/30">
                    <div className="flex flex-col">
                        <span className="text-sm font-bold text-slate-200">Jadikan Utama (Primary)</span>
                        <span className="text-[10px] text-slate-500">Hanya satu perangkat yang bisa primary</span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={deviceForm.primary}
                            onChange={(e) => setDeviceForm({ ...deviceForm, primary: e.target.checked })}
                        />
                        <div className="w-11 h-6 bg-slate-700 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-cyan-500/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyan-600 shadow-inner"></div>
                    </label>
                </div>

                {/* --- Input Nama --- */}
                <InputDefault
                    id="name"
                    label="Nama Perangkat"
                    type="text"
                    placeholder="Contoh: HP Sales 1"
                    value={deviceForm.name}
                    onChange={(e) => setDeviceForm({ ...deviceForm, name: e.target.value })}
                    required
                />
        

                {/* --- Input Nomor HP --- */}
                <InputDefault
                    id="phone_number"
                    label="Nomor WhatsApp"
                    type="tel"
                    placeholder="6281234567890"
                    value={deviceForm.phone_number}
                    onChange={(e) => setDeviceForm({ ...deviceForm, phone_number: e.target.value })}
                    disabled={true}
                />
               
                {/* --- Action Button --- */}
                {loading ? (
                    <div className="flex items-center justify-center py-3 gap-2 text-cyan-400 font-medium">
                        <div className="animate-spin w-5 h-5 border-2 border-cyan-500 border-t-transparent rounded-full"></div>
                        <span>Menyimpan...</span>
                    </div>
                ) : (
                    <button
                        type="submit"
                        className="w-full py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 text-white font-bold transition-all shadow-lg shadow-cyan-600/25 flex items-center justify-center gap-2 active:scale-[0.98]"
                    >
                        <FaSave className="text-sm" /> Simpan Perubahan
                    </button>
                )}
            </form>
        </ModalWraper>
    );
};